module.exports = __webpack_public_path__ + "img/daohangimg.2a3487af.png";